<dx-data-grid
    class="grid theme-dependent"
    [height]="'100%'"
    [dataSource]="dataSourceByHour"
    [allowColumnResizing]="false"
    [autoNavigateToFocusedRow]="false"
    [columnAutoWidth]="true"
    [showBorders]="true"
    [wordWrapEnabled]="true"
    [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'file-import-by-hour-grid-state', savingTimeout: 0 }"
>
    <dxo-toolbar>
        <dxi-item location="before" locateInMenu="auto">
            <div *dxTemplate>
                <dx-date-box
                    [value]="selectedDate"
                    (onValueChanged)="onDateChanged($event)"
                    [width]="170"
                ></dx-date-box>
            </div>
        </dxi-item>
        <dxi-item
            location="before"
            locateInMenu="never"
            widget="dxButton"
            showText="inMenu"
            [options]="{ text: 'Refresh', icon: 'refresh', onClick: refresh, stylingMode: 'text' }"
        ></dxi-item>
    </dxo-toolbar>
    <dxo-scrolling rowRenderingMode="virtual" [scrollByContent]="true"></dxo-scrolling>

    <dxi-column
        dataField="type.fileType"
        caption="Reporting Files"
        cellTemplate="type"
        [minWidth]="200"
    ></dxi-column>

    @for (h of [].constructor(24); track hour; let hour = $index) {
        <dxi-column
            alignment="center"
            [dataField]="hour.toString()"
            [caption]="toDateTimeString(hour) | date:'ha' | lowercase"
            [width]="60"
            cellTemplate="hour"
            [cssClass]="getHighlightedClass(hour)"
        >
        </dxi-column>
    }

    <div *dxTemplate="let cell of 'hour'">
        <div class="text-center">
            @if (!isCellEmpty(getCellData(cell)[cell.column.dataField])) {
                <div id="group-{{ cell.columnIndex }}-{{ cell.rowIndex }}"
                     (mouseenter)="showPopover(cell)"
                     (mouseleave)="scheduleHidePopover(cell)">
                    @if (isCellSuccess(cell.data[cell.column.dataField])) {
                        <i class="fas fa-check text-success"></i>
                    } @else {
                        <i class="fas fa-exclamation-triangle text-danger"></i>
                    }
                </div>

                <dx-popover
                    target="#group-{{ cell.columnIndex }}-{{ cell.rowIndex }}"
                    [showCloseButton]="true"
                    [(visible)]="cell.popupVisible"
                    width="95%"
                    [maxWidth]="500"
                >
                    <div *dxTemplate="let data = model; of: 'content'">
                        <div class="text-wrap text-break"
                             (mouseenter)="showPopover(cell)"
                             (mouseleave)="scheduleHidePopover(cell)">
                            <h6 class="font-weight-bold">{{ cell.data[cell.column.dataField].fileType }}</h6>
                            @if (getCellData(cell)[cell.column.dataField].message) {
                                <p [ngClass]="{ 'text-danger': isCellError(getCellData(cell)[cell.column.dataField]) }"
                                   [innerHtml]="getCellData(cell)[cell.column.dataField].message | nl2br"></p>
                            }
                            <p>
                                <a href="#" appSignedLink="{{ getCellData(cell)[cell.column.dataField].url}}" title="Download">
                                    {{ getCellData(cell)[cell.column.dataField].fileName }}
                                </a>
                            </p>
                        </div>
                    </div>
                </dx-popover>
            }
        </div>
    </div>
    <div *dxTemplate="let cell of 'type'">
        <span class="me-2">{{ getCellData(cell)['type'].fileType | importFileType }}</span>
        <a
            href="javascript:void(0)"
            class="pull-right"
            [class.disabled]="uploadManager.isTypeActive(getCellData(cell)['type'].fileType)"
            (click)="onUploadButtonClick(getCellData(cell)['type'])"
        ><i class="ml-2 fas fa-upload"></i></a>
    </div>
</dx-data-grid>

<input
    type="file"
    id="file-input"
    name="file"
    style="visibility: hidden"
    (change)="uploadFile($event)"
/>
